import axios from 'axios'
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCarouseltoppages,
  addingCarouseltoppages,
  addingCarouseltoppagesFailed,
  CarouseltoppagesAction,
  CarouseltoppagesActionTypes,
  editedCarouseltoppages,
  editingCarouseltoppages,
  editingCarouseltoppagesFailed,
  foundCarouseltoppages,
  loadedCarouseltoppages,
  loadingCarouseltoppages,
  loadingCarouseltoppagesFailed,
  removedCarouseltoppage,
  removingCarouseltoppage,
  removingCarouseltoppageFailed,
  searchingCarouseltoppages,
  searchingCarouseltoppagesFailed,
  softRemovedCarouseltoppages,
  softRemovingCarouseltoppages,
  softRemovingCarouseltoppagesFailed,
} from '../actions/carouseltoppagesActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'
import { API_URL } from '../../config/apiConfig'

const searchCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.SEARCH_CAROUSELTOPPAGES)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/carouseltoppages/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCarouseltoppages(response.data, action.keep)),
        startWith(searchingCarouseltoppages()),
        catchError(() => of(searchingCarouseltoppagesFailed()))
      )
    })
  )

const loadCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.LOAD_CAROUSELTOPPAGES)),
    switchMap((action) => {
      let url = `${API_URL}/api/carouseltoppages/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCarouseltoppages(response.data)),
        startWith(loadingCarouseltoppages()),
        catchError(() => of(loadingCarouseltoppagesFailed()))
      )
    })
  )
}

const addCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.ADD_CAROUSELTOPPAGES)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/carouseltoppages/`, data, config)).pipe(
        map((response) => addedCarouseltoppages(response.data)),
        startWith(addingCarouseltoppages()),
        catchError((err) => of(addingCarouseltoppagesFailed(err.response)))
      )
    })
  )

const removeCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.REMOVE_CAROUSELTOPPAGE)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/carouseltoppages/${action.payload._id}`)).pipe(
        map((response) => removedCarouseltoppage()),
        startWith(removingCarouseltoppage()),
        catchError(() => of(removingCarouseltoppageFailed()))
      )
    )
  )

const softRemoveCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.SOFT_REMOVE_CAROUSELTOPPAGES)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/carouseltoppages/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCarouseltoppages(response.data.record)),
        startWith(softRemovingCarouseltoppages()),
        catchError((err) => of(softRemovingCarouseltoppagesFailed(err.response)))
      )
    )
  )

const editCarouseltoppagesEpic: Epic<CarouseltoppagesAction, CarouseltoppagesAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CarouseltoppagesActionTypes.EDIT_CAROUSELTOPPAGES)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/carouseltoppages/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCarouseltoppages(response.data)),
        startWith(editingCarouseltoppages()),
        catchError((err) => of(editingCarouseltoppagesFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCarouseltoppagesEpic,
  loadCarouseltoppagesEpic,
  addCarouseltoppagesEpic,
  removeCarouseltoppagesEpic,
  softRemoveCarouseltoppagesEpic,
  editCarouseltoppagesEpic
)
